// extracted by mini-css-extract-plugin
export default {"listItem":"UniversityAccords_listItem__0hQri"};